<div class="splash-screen-container">
  <div class="splash-screen-content">
    <img class="splash-screen-content-logo" src="{{logoUrl}}" alt="">
  </div>
</div>
